import { axiosCompanyPortalInstance } from "./";

const clientReportsPath = (eventId) => `/events/${eventId}/client_reports`;

/**
 * GET /company_portal/v1/events/:eventId/client_reports
 * Pagination metadata comes back in the `Current-Page` / `Total-Count` /
 * `Total-Pages` headers. `page: -1` returns every report unpaginated.
 */
const getCompanyClientReports = (eventId, params = {}) =>
  axiosCompanyPortalInstance.get(clientReportsPath(eventId), { params });

/** POST /company_portal/v1/events/:eventId/client_reports — requires Manage Reports `can_add`. */
const createCompanyClientReport = (eventId, data) =>
  axiosCompanyPortalInstance.post(clientReportsPath(eventId), data);

/**
 * GET /company_portal/v1/events/:eventId/client_reports/:id — returns a fresh `upload_url`.
 * Silent: the download / preview flows show their own progress, not the global loader.
 */
const getCompanyClientReport = (eventId, id) =>
  axiosCompanyPortalInstance.get(`${clientReportsPath(eventId)}/${id}`, {
    handlerEnabled: false,
  });

/**
 * DELETE /company_portal/v1/events/:eventId/client_reports/:id — requires the
 * company owner or Manage Reports `can_delete`, and `is_deletable: true` on the
 * report. Silent: the Delete flow shows its own error message.
 */
const deleteCompanyClientReport = (eventId, id) =>
  axiosCompanyPortalInstance.delete(`${clientReportsPath(eventId)}/${id}`, {
    handlerEnabled: false,
  });

export {
  getCompanyClientReports,
  createCompanyClientReport,
  getCompanyClientReport,
  deleteCompanyClientReport,
};
